var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "label",
        {
          staticClass: "el-form--label-top",
          class: { hiddenlabel: !_vm.fieldValue },
        },
        [_vm._v(_vm._s(_vm.placeholderValue) + "\n    ")]
      ),
      _vm._v(" "),
      _vm.fieldType == "select"
        ? _c(
            "el-select",
            {
              staticClass: "w-100",
              attrs: {
                disabled: _vm.disabled,
                filterable: "",
                placeholder: _vm.placeholderValue,
              },
              on: {
                change: function ($event) {
                  return _vm.$emit("change")
                },
              },
              model: {
                value: _vm.fieldValue,
                callback: function ($$v) {
                  _vm.fieldValue = $$v
                },
                expression: "fieldValue",
              },
            },
            _vm._l(_vm.options, function (country, countryCode) {
              return _c(
                "el-option",
                {
                  key: "countrydrop_" + countryCode,
                  attrs: {
                    label: country["country"] ? country["country"] : country,
                    value: country["country"] ? country["country"] : country,
                  },
                },
                [
                  country["country"]
                    ? _c("span", {
                        staticClass: "fi",
                        class: "fi-" + country["countryCode"],
                        staticStyle: {},
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  country["country"]
                    ? _c("span", [_vm._v(_vm._s(country["country"]))])
                    : _vm._e(),
                ]
              )
            }),
            1
          )
        : _vm.fieldType == "textarea"
        ? _c("el-input", {
            attrs: { disabled: _vm.disabled, type: "textarea" },
            model: {
              value: _vm.fieldValue,
              callback: function ($$v) {
                _vm.fieldValue = $$v
              },
              expression: "fieldValue",
            },
          })
        : _vm.fieldType == "date"
        ? _c("el-input", {
            attrs: {
              disabled: _vm.disabled,
              type: "date",
              min: _vm.min,
              max: _vm.max,
            },
            model: {
              value: _vm.fieldValue,
              callback: function ($$v) {
                _vm.fieldValue = $$v
              },
              expression: "fieldValue",
            },
          })
        : _c("el-input", {
            attrs: {
              placeholder: _vm.placeholderValue,
              disabled: _vm.disabled,
            },
            model: {
              value: _vm.fieldValue,
              callback: function ($$v) {
                _vm.fieldValue = $$v
              },
              expression: "fieldValue",
            },
          }),
      _vm._v(" "),
      [
        "job_title",
        "project_title",
        "state_country_of_production",
        "designer_name",
        "architect_name",
        "client",
        "contractor",
        "manufacturer",
        "photographer",
        "video_link",
        "other",
        "design_team",
        "phone_number",
        "fax",
        "lead_architects",
        "landscape_architects",
        "general_contractor",
      ].indexOf(_vm.placeholder) >= 0
        ? _c("span", { staticClass: "input-hint" }, [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.__(
                    "fieldnames.hint." +
                      (_vm.formName ? _vm.formName + "." : "") +
                      _vm.formStep +
                      "_" +
                      _vm.placeholder
                  )
                ) +
                "\n    "
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }